<template>
    <v-card class="my-2 product-card" variant="outlined">
        <div class="d-flex wrapper">
            <div class="product-card__img-wrapper" style="position: relative">
                <v-img
                    tile
                    :src="$filters.imageUrl(thumb, 350)"
                    :alt="name"
                    eager
                    width="200"
                    max-width="200"
                    height="200"
                    :lazy-src="$filters.srcHost('/placeholder.png')"
                    class="me-2"
                    @error="imgError = true"
                >
                    <template v-slot:placeholder>
                        <v-row v-show="!imgError && thumb" class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular indeterminate color="grey-lighten-5" />
                        </v-row>
                    </template>
                </v-img>
                <slot name="wishlist" />
            </div>
            <div class="wrapper-content ma-2 flex-grow-1 flex-shrink-1">
                <slot />
            </div>
            <div class="ma-4 price-col flex-shrink-0 text-right">
                <slot name="priceCol" />
            </div>
            <recommended-icon v-if="isRecommended" class="recommended-thumb" />
        </div>
        <v-expand-transition>
            <slot name="offers" />
        </v-expand-transition>
    </v-card>
</template>

<script lang="ts">
    import {Component, Emit, Prop, Vue} from 'vue-facing-decorator'
    import RecommendedIcon from '@/components/search/RecommendedIcon.vue'

    @Component({
        components: {RecommendedIcon},
    })
    export class ProductCardLayout extends Vue {
        @Prop({required: true}) thumb
        @Prop({required: true}) name
        @Prop({required: false}) productLink
        @Prop({required: true}) offersCount
        @Prop({default: false, type: Boolean}) isRecommended
        @Prop({default: false, type: Boolean}) comparisonMode

        @Prop({required: true}) _expandedCount
        @Prop({required: true}) _expandedLimit

        @Emit()
        changeExpandedCount(val) {
            return val
        }

        @Emit()
        changeExpandedLimit(val) {
            return val
        }

        imgError = false

        toggleOffers() {
            this.expandedCount = this.expandedCount ? 0 : this.expandedLimit
        }

        get expandedCount() {
            return this._expandedCount
        }

        set expandedCount(val) {
            this.changeExpandedCount(val)
        }

        get expandedLimit() {
            return this._expandedLimit
        }

        set expandedLimit(val) {
            this.changeExpandedLimit(val)
        }
    }

    export default ProductCardLayout
</script>

<style scoped lang="scss">
    .product-card {
        overflow: hidden;
        cursor: unset;
    }

    .wrapper {
        height: 200px;
    }

    .price-col {
        width: 180px;
    }

    .recommended-thumb {
        position: absolute;
        top: 0;
        left: 0;
        width: 40px;
        height: 40px;
    }

    //TODO Remove after layout redesign
    @media (max-width: 1440px) {
        .price-col {
            width: 130px;
        }
    }

    :deep(.v-expansion-panel) {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }
</style>
